<template>
  <div class="input-container">
    <input
      id="password"
      type="password"
      name="password"
      autocomplete="false"
    >
    <label
      for="first__pst-i"
      class="input__label"
    >
      Password
    </label>
    <input
      id="first__pst-i"
      v-model.lazy="$v.plainPassword.$model"
      :class="{'input--error' : ($v.plainPassword.$invalid === true && $v.plainPassword.$error === true) || incorrectPassword === true}"
      class="input"
      type="password"
      autocomplete="off"
      autocapitalize="off"
      name="first__pst-i"
      @focusout="updatePassword"
    >
    <span
      v-show="($v.plainPassword.$error === true || incorrectPassword === true)"
      class="has__error"
    >
      {{ error }}
    </span>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import { bus } from '../../main'

export default {
  data () {
    return {
      plainPassword: '',
      incorrectPassword: false
    }
  },
  computed: {
    error () {
      let error = 'Invalid password'
      if (this.plainPassword.length < 8) {
        error = 'Password must contain at least 8 symbols'
      } else if (this.incorrectPassword === true) {
        error = 'Incorrect password'
      } else {

      }
      return error
    }
  },
  watch: {
    '$v.plainPassword.$invalid': function (val) {
      this.$emit('input', this.plainPassword)
      this.$emit('valid', (val === false), this.$options._componentTag)
    }
  },
  mounted () {
    bus.$on('triggerPasswordField', payLoad => {
      this.incorrectPassword = payLoad
    })
  },
  validations: {
    plainPassword: {
      required,
      minLength: minLength(8)
    }
  },
  methods: {
    triggerTouch () {
      this.$v.$touch()
    },
    invalidPassword () {
      this.incorrectPassword = true
    },
    updatePassword () {
      this.incorrectPassword = false
      this.$emit('input', this.plainPassword)
    }
  }
}
</script>

<style scoped>

</style>
